module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fronttitle "
  }, [_vm._v("Translator’s Note")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("In Hebrew, the title of this book is "), _c('em', [_vm._v("Hesed Sefaradi. Hesed")]), _vm._v(" (with a guttural "), _c('em', [_vm._v("h")]), _vm._v(") eludes precise translation and connotes compassion, kindness, love, and charity; a fair equivalent is the Latin "), _c('em', [_vm._v("caritas. Sefaradi")]), _vm._v(" means “Spanish” but also “Sephardic,” referring specifically to Jews whose ancestors were expelled from Spain in 1492 and more broadly to “Oriental” Jews from Arabic-speaking countries in North Africa and the Middle East. The double meaning helps the reader get the picture.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133e2d69","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front02.vue
// module id = 63
// module chunks = 0